import styled from 'styled-components';
import fn from '../../helpers/fn';

export default fn(__filename, styled.div`
  ${({ breakpoint }) => breakpoint && `
    @media screen and (${breakpoint}) {
      display: none;
    }
  `}
`);



// WEBPACK FOOTER //
// ./src/components/blocks/Hide.js